import { IsNotEmpty, IsString, IsArray } from 'class-validator';

export class AbilityMenuSortingDTO {

   @IsNotEmpty()
   @IsArray()
   @IsString({
      each: true
   })
   sortOrder: Array<string>;

}
